import { render } from "./ImportExportForm.vue?vue&type=template&id=0f181151"
import script from "./ImportExportForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportExportForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/search-words/components/ImportExportForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f181151"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f181151', __exports__)) {
    api.reload('0f181151', __exports__)
  }
  
  module.hot.accept("./ImportExportForm.vue?vue&type=template&id=0f181151", () => {
    api.rerender('0f181151', render)
  })

}


export default __exports__